import { computed } from 'vue'

import { injectBlockFormPresenterValues } from '@/features/settingsManagement/builder/edit/plugins/formPlugin/useBlockFormPresenterValues.js'

export function useFieldValueRenderer() {
  const blockFormPresenterValues = injectBlockFormPresenterValues()
  const fieldTemplateRendererComponent = computed(() => {
    // it can be empty
    if (!blockFormPresenterValues) {
      return null
    }

    return blockFormPresenterValues.fieldValueRendererTemplate
  })

  return {
    fieldTemplateRendererComponent,
  }
}
